export default "__VITE_ASSET__Dc_b4fLI__"